import { Table, Button, Modal, Form, DatePicker, Input } from 'antd';
import useAcademicMobility from './useNotificationPage';
import { Link } from 'react-router-dom';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import RowSpan from '../../../ui/RowSpan';
import Page from '../../../ui/Page';
import moment from 'moment';

const AcademicMobilityPage = () => {
    const { notification, column, currentPage, totalPages, setCurrentPage, isModalOpen, handleCancel, students, studentColumn, studentTotalPages,
        studentCurrentPage, setStudentCurrentPage, studentsNumber, form, setParams, setPageSize, pageSize } = useAcademicMobility();

    return (
        <Page title='Notification List'>
            <RowSpan
                left={
                    <Form form={form} onFinish={e => setParams(e)} >
                        <Form.Item label="Receiver's full name"
                            name="fullname"
                            style={{ width: 500 }}
                        >
                            <Input
                                placeholder="Enter student's full name"
                            />
                        </Form.Item>
                        <Form.Item
                            label="Start date"
                            name="startDate"
                            getValueFromEvent={(onChange) => onChange ? moment(onChange).format('YYYY-MM-DD') : null}
                            getValueProps={(i) => ({ value: i ? moment(i) : null })}
                            style={{ width: '100%' }}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format={'YYYY-MM-DD'}
                                placeholder="Start date"
                            />
                        </Form.Item>
                        <Form.Item
                            label="End date"
                            name="endDate"
                            getValueFromEvent={(onChange) => onChange ? moment(onChange).format('YYYY-MM-DD') : null}
                            getValueProps={(i) => ({ value: i ? moment(i) : null })}
                            style={{ width: '100%' }}
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                format={'YYYY-MM-DD'}
                                placeholder="End date"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Search
                            </Button>
                        </Form.Item>
                    </Form>
                }
                right={
                    <Link to="/notification-create">
                        <Button type="primary" icon={<PlusOutlined />}>
                            Add new Notification
                        </Button>
                    </Link>
                }
            />
            <br />
            <Table
                pagination={{
                    current: currentPage,
                    total: totalPages * 10,
                    pageSize: pageSize,
                    onChange: (page) => setCurrentPage(page),
                    onShowSizeChange: (current, size) => setPageSize(size),
                }}
                dataSource={notification.map((notification, index) => ({
                    key: notification.id,
                    number: index + 1,
                    text: notification.text,
                    createdDate: notification.createdAt,
                })).sort((a, b) => a.number - b.number)}
                columns={column}
            />
            <Modal title={'Количество студентов: ' + studentsNumber} open={isModalOpen} onCancel={handleCancel} width={800}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                ]}>
                <Table
                    pagination={{
                        current: studentCurrentPage,
                        total: studentTotalPages * 10,
                        pageSize: 10,
                        onChange: (page) => setStudentCurrentPage(page),
                    }}
                    dataSource={students.map((student, index) => ({
                        key: student.id,
                        number: index + 1,
                        student: student.user.name + " " + student.user.surname,
                        isRead: student.isRead,
                        readAt: student.readAt,
                        moodleMessageIsRead: student.moodleMessageIsRead,
                        moodleMessageReadAt: student.moodleMessageReadAt,
                    }))}
                    columns={studentColumn}
                    rowKey={(record) => record.number}
                />
            </Modal>
        </Page >
    )
}

export default AcademicMobilityPage;

